import React, { useCallback } from "react";
import useGlobalContext from "../../hooks/useGlobalContext.js";
import useEvents from "../../hooks/useEvents.js";
import TrackerContext from "./TrackerContext.js";
import useC360Tracker from "../../hooks/useC360Tracker.js";
const debug = require("debug")("trackers");
function TrackerProvider(props) {
    const { env } = useGlobalContext();
    const { grumble, jsError } = useEvents();
    const c360Tracker = useC360Tracker();
    const { children } = props;
    const skipTracking = (!env || env === "dev") && !debug.enabled;
    const maxRetries = 3;
    const retryDelay = 1000;
    const isC360Dev = useCallback((eventType) => eventType === "c360" && env === "dev", [env]);
    const retry = useCallback((event, cb) => {
        if (event.retries >= maxRetries) {
            grumble("Tracker : failed to report event", event.type);
        }
        else {
            setTimeout(() => {
                cb({ ...event, retries: event.retries + 1 });
            }, retryDelay);
        }
    }, [grumble]);
    const triggerTrackExternal = useCallback((event) => {
        switch (event.type) {
            case "gtm-price-accuracy":
            case "gtm-skyscanner-confirmation":
            case "gtm-byeah-confirmation":
            case "gtm-byeah-search-results":
            case "gtm-route-change":
            case "gtm-adtech":
                window.dataLayer.push({ ...event.args[0] });
                break;
            case "gtag":
                if (typeof window.gtag === "function") {
                    window.gtag(...event.args);
                }
                else {
                    retry(event, triggerTrackExternal);
                }
                break;
            case "RISKX":
                window.riskifiedBeaconLoad(event.data?.sessionId);
                break;
            case "c360":
                void c360Tracker.c360SendEvent(event.args[0]);
                break;
            default:
                jsError(new Error(`Tracker : unhandled event type - ${event.type}`));
                break;
        }
    }, [c360Tracker, jsError, retry]);
    const trackExternal = useCallback((event) => {
        if (!skipTracking || isC360Dev(event.type)) {
            try {
                debug("event sent: %o", event);
                triggerTrackExternal({ ...event, retries: 0 });
            }
            catch (err) {
                debug.error(err);
                jsError(new Error(`Caught exception in TrackerProvider: ${err}`));
            }
        }
    }, [skipTracking, isC360Dev, triggerTrackExternal, jsError]);
    debug("Initialized TrackerProvider");
    return React.createElement(TrackerContext.Provider, { value: { trackExternal } }, children);
}
export { TrackerProvider };
